export default class FieldAllowedAttributeTypes {
  public static readonly MULTIPLE_SUGGESTIONS_SEARCH_SELECT: string = 'multiple_suggestions_search_select';
  public static readonly MULTIPLE_SEARCH_SELECT: string = 'multiple_search_select';
  public static readonly MULTIPLE_CUSTOM_SELECT: string = 'multiple_custom_select';
  public static readonly TEXT: string = 'text';
  public static readonly RICH_EDITOR: string = 'rich_editor';
  public static readonly SEARCH_SELECT: string = 'search_select';
  public static readonly TEXTAREA: string = 'textarea';
  public static readonly FILE: string = 'file';
  public static readonly SELECT: string = 'select';
  public static readonly INPUT_SELECT: string = 'input_select';
  public static readonly CHECKBOX: string = 'checkbox';
  public static readonly SWITCH: string = 'switch';
  public static readonly FOCUS: string = 'focus';
  public static readonly EMAIL: string = 'email';
}
